import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/RequestAssignment"
    : "SLN/SolarentOperator/RequestAssignment";

const parseStatusPayload = (res) => {
  const payload = res?.data?.data ?? res?.data ?? res;
  return payload && typeof payload === "object" ? payload : {};
};

const RequestAssignmentApi = {
  getStatus: async (source) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `${baseBySource(source)}/Status`
      );
      const payload = parseStatusPayload(res);
      return {
        enabled: !!(
          payload.enabled ??
          payload.Enabled ??
          res?.enabled ??
          res?.Enabled
        ),
        canClaimRequests: !!(
          payload.canClaimRequests ?? payload.CanClaimRequests
        ),
        openCasesCount:
          payload.openCasesCount ?? payload.OpenCasesCount ?? 0,
        maxOpenCasesPerOperator:
          payload.maxOpenCasesPerOperator ?? payload.MaxOpenCasesPerOperator ?? 20,
        isAtOpenCasesLimit: !!(
          payload.isAtOpenCasesLimit ?? payload.IsAtOpenCasesLimit
        ),
        currentUserKind:
          payload.currentUserKind ??
          payload.CurrentUserKind ??
          null,
        currentUserId:
          payload.currentUserId ?? payload.CurrentUserId ?? null,
        currentUserRoleName:
          payload.currentUserRoleName ?? payload.CurrentUserRoleName ?? null,
        ok: res?.isSuccess !== false,
      };
    } catch {
      return {
        enabled: false,
        canClaimRequests: false,
        currentUserKind: null,
        currentUserId: null,
        currentUserRoleName: null,
        ok: false,
      };
    }
  },
  claim: async (source, requestId) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Claim`, { requestId }),
  release: async (source, requestId, reason = "") =>
    DefaultApiService.postApi(`${baseBySource(source)}/Release`, {
      requestId,
      reason,
    }),
};

export default RequestAssignmentApi;
